import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/logo.jpg';

function Header() {
  return (
    <header className="header">
      <Link to="/" className="logo-container">
        <img src={logo} alt="锐齐课堂" className="logo" />
        <h1 className="logo-text">锐齐课堂</h1>
      </Link>
      <nav className="nav">
        <ul>
          <li><a href="#" className="active">Unity课程</a></li>
          <li><a href="#">技术美术</a></li>
          <li><a href="#">关于我们</a></li>
        </ul>
      </nav>
      <div className="header-right">
        <div className="search">
          <input type="text" placeholder="搜索" />
          <i className="search-icon">🔍</i>
        </div>
        <div className="user-avatar">
          <img src="https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/system/2021/04-02/185727772fa9782776.jpg?version=25.1.5" alt="用户头像" />
        </div>
      </div>
    </header>
  );
}

export default Header; 